import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingCurrentService {
  private isLoading = new BehaviorSubject<boolean>(false);
  isLoading$ = this.isLoading.asObservable();

  loading!: boolean;

  show(): void {
    this.loading = true;
    this.isLoading.next(true);
  }

  hide(): void {
    this.loading = false;
    this.isLoading.next(false);
  }
}